module.exports = __webpack_public_path__ + "img/icon_1_28.b1d6c171.png";